import { render, staticRenderFns } from "./informationPriceView.vue?vue&type=template&id=31df8588&scoped=true"
import script from "./informationPriceView.vue?vue&type=script&lang=js"
export * from "./informationPriceView.vue?vue&type=script&lang=js"
import style0 from "./informationPriceView.vue?vue&type=style&index=0&id=31df8588&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31df8588",
  null
  
)

export default component.exports